export function slugifyTournamentName(name: string) {
  if (!name) return "";
  return encodeURIComponent(
    name
      .replace(/:/g, "")
      .replace(/ - /g, " ")
      .replace(/\//g, "-")
      .replace(/#/g, "")
      .replace(/\[/g, "")
      .replace(/\]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .toLowerCase()
  );
}
